import { gql } from '@apollo/client';

const GET_USER_EMAIL_PREFERENCES = gql`
  query GetUserEmailPreferences {
    userEmailPreferences {
      AppraisalDataAlerts
      CheckPointDataAlerts
      ReportManagementFdaAlerts
      ReportManagementOrganizationAlerts
      UserManagementAlerts
    }
    userEmailPreferencesAccessibilities {
      AppraisalDataAlerts
      CheckPointDataAlerts
      ReportManagementFdaAlerts
      ReportManagementOrganizationAlerts
      UserManagementAlerts
    }
  }
`;

export default GET_USER_EMAIL_PREFERENCES;
